function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m7.5 14.5c-1.87 0-3.63-.73-4.95-2.05s-2.05-3.08-2.05-4.95c0-1.42.42-2.77 1.19-3.91.4-.59 1.26-.63 1.77-.13.4.4.43 1.02.12 1.5-.49.75-.75 1.62-.75 2.54 0 1.53.73 2.95 2.03 3.85 1.57 1.09 3.73 1.09 5.29-.01 1.29-.91 2.01-2.32 2.01-3.84 0-.92-.26-1.79-.75-2.54-.31-.48-.28-1.1.12-1.5.5-.5 1.37-.46 1.77.13.78 1.15 1.19 2.5 1.19 3.91 0 1.87-.73 3.63-2.05 4.95s-3.08 2.05-4.95 2.05zm0-7c-.64 0-1.17-.52-1.17-1.17v-4.66c0-.64.52-1.17 1.17-1.17.64 0 1.17.52 1.17 1.17v4.67c0 .64-.52 1.17-1.17 1.17z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 15"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/power-outlined.77752e93.svg";
export { SvgComponent as ReactComponent };